import React from "react";
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const BookType = ({ ...props }) => {
  const { AccountBooktypes, selectedBookType } = props;

  return (
    <UncontrolledDropdown style={{ justifyContent: "center", alignItems: "center", display: "flex" }}>
      <DropdownToggle color="light" disabled={false} caret>
        <i className="fa fa-book mr-2" />
        Book Type: {selectedBookType}
      </DropdownToggle>
      <DropdownMenu>
        {AccountBooktypes.map((bk) => (
          <DropdownItem key={bk} value={bk} onClick={(e) => props.toggleBookType(e.target.value)}>
            {bk}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default BookType;
